import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { PAGE_HASH } from "../../../../atoms/location/locationAtom";
import useHashBoolean from "../../../../hooks/reactRouterHooks/useHashBoolean";
import { useMediaQueryBreakpoint } from "../../../../hooks/useMediaQuery";
import { SidePanel } from "../../SidePanel/SidePanel";
import { WrappedEditReleaseTrackForm } from "../EditReleaseTrackForm/WrappedEditReleaseTrackForm";
import { useShowEditReleaseTrackSidePanel } from "./useShowEditReleaseTrackSidePanel";

export const EditReleaseTrackSidePanel = () => {
  const { isOpen } = useHashBoolean({
    value: PAGE_HASH.EDIT_RELEASE_TRACK,
  });
  const showEditReleaseTrackSidePanel = useShowEditReleaseTrackSidePanel();
  const { isDesktop } = useMediaQueryBreakpoint();
  const [searchParams] = useSearchParams();
  const releaseTrackId = searchParams.get("release_track_id");

  const releaseTrackIdNumber = useMemo(() => {
    return releaseTrackId ? parseInt(releaseTrackId) : undefined;
  }, [releaseTrackId]);

  const handleClose = useCallback(() => {
    showEditReleaseTrackSidePanel(releaseTrackIdNumber ?? 0);
  }, [showEditReleaseTrackSidePanel, releaseTrackIdNumber]);

  return (
    <SidePanel
      fillScreen={!isDesktop}
      onClose={handleClose}
      isOpen={isOpen}
      sidePanelStyle={{
        ...(isDesktop && { maxWidth: "800px" }),
      }}
    >
      <WrappedEditReleaseTrackForm
        handleCancel={handleClose}
        releaseTrackId={releaseTrackIdNumber}
        handleSave={() => {
          handleClose();
        }}
      />
    </SidePanel>
  );
};
